/* eslint-disable no-restricted-globals */
const isNumberLike = (value: string | number) => {
  if (typeof value === 'number') return true;
  if (typeof value === 'string') {
    if (!value) return false;
    if (value.indexOf(',') > -1) return false;

    return !isNaN(value) && !isNaN(Number.parseFloat(value));
  }

  return false;
};

export default isNumberLike;
